import { render, staticRenderFns } from "./InfiniteList.vue?vue&type=template&id=7f172e0c&"
import script from "./InfiniteList.vue?vue&type=script&lang=ts&"
export * from "./InfiniteList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports